import { iframeResize } from 'iframe-resizer'

export default class BlockAntidotsEngine {
    constructor() {
        BlockAntidotsEngine.init()
    }

    static init() {
        iframeResize({ heightCalculationMethod: 'lowestElement' }, '#antidots-widget')
    }
}

new BlockAntidotsEngine()
